import React from "react";
import "./App.css";
function Footer() {
  return (
    <div className="footer">
      <ul className="copyright">
        <li>
          © {new Date().getFullYear()} all rights reserved by{" "}
          <a
            style={{ textDecoration: "none", color: "white" }}
            title="Sanchit"
            href="https://www.linkedin.com/in/sanchit-k-09a172199/"
          >
            <h5>Sanchit Kalsi a.k.a. darksoul26</h5>
          </a>
        </li>
      </ul>
    </div>
  );
}
export default Footer;
